<div class="notifications-header">
  <a
    [ngClass]="{ active: editMode }"
    (click)="openNotifications()"
    (mouseenter)="iconHovered = true"
    (mouseleave)="iconHovered = false"
    #popoverActivation
    class="full-opacity icon-notification flex flex-center-center"
    mat-icon-button
  >
    @if (editMode || iconHovered) {
      <mat-icon color="accent-light">notifications</mat-icon>
    }
    @if (!editMode && !iconHovered) {
      <mat-icon color="light">notifications_none</mat-icon>
    }
  </a>
  @if (unseenNotificationsCounter) {
    <span class="notifications-header-counter">{{ unseenNotificationsCounter }}</span>
    <span [ngClass]="{ 'pulse': shouldPulse }"></span>
  }
</div>
